import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface PropTypes extends BoxProps {
  name: string;
  children: JSX.Element | JSX.Element[]
}

function FaqCategory(props: PropTypes): JSX.Element {
  const { name, children, ...boxProps } = props;
  return (
    <Box {...boxProps}>
      <Box marginBottom={2}>
        <Typography fontWeight={700} variant={'h5'}>
          {name}
        </Typography>
      </Box>
      <Box>
        {children}
      </Box>
    </Box>
  );
}

export default FaqCategory;